export default {
  tabCluster: 'Cluster Device Config',
  tabScene: 'Application Scene Config',

  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  confirm: 'Confirm',
  operation: 'Actions',
  image: 'Image',
  createTime: 'Created At',
  updateTime: 'Updated At',

  deleteConfirmTitle: 'Confirm Delete',
  deleteConfirmContent: 'Delete "{name}"?',
  deleteConfirm: 'Delete',
  deleteSuccess: 'Deleted successfully',
  addSuccess: 'Created successfully',
  editSuccess: 'Updated successfully',

  selectImage: 'Select Image',
  imageRequired: 'Please upload an image',

  cluster: {
    addTitle: 'Add Cluster Device',
    editTitle: 'Edit Cluster Device',
    deviceType: 'Device Type',
    deviceTypePlaceholder: 'Select device type',
    deviceTypeRequired: 'Please select device type',
    name: 'Device Name',
    namePlaceholder: 'Enter device name',
    nameRequired: 'Please enter device name',
    nameEn: 'Device Name (EN)',
    nameEnPlaceholder: 'Enter device name in English',
    nameEnRequired: 'Please enter device name in English',
    status: 'Status',
    statusPlaceholder: 'Select status',
    statusRequired: 'Please select status',
    statusNormal: 'Normal',
    statusDisabled: 'Disabled',
    online: 'Online Status',
    onlinePlaceholder: 'Select online status',
    onlineRequired: 'Please select online status',
    onlineYes: 'Online',
    onlineNo: 'Offline',
    address: 'Address',
    addressPlaceholder: 'Enter address',
    addressRequired: 'Please enter address',
    addressEn: 'Address (EN)',
    addressEnPlaceholder: 'Enter address in English',
    addressEnRequired: 'Please enter address in English',
    deviceTypeCol: 'Device Type',
    addressCol: 'Address',
  },

  scene: {
    addTitle: 'Add Application Scene',
    editTitle: 'Edit Application Scene',
    name: 'Scene Name',
    namePlaceholder: 'Enter scene name',
    nameRequired: 'Please enter scene name',
    nameEn: 'Name (EN)',
    nameEnPlaceholder: 'Enter name in English',
    nameEnRequired: 'Please enter name in English',
    description: 'Description',
    descriptionPlaceholder: 'Enter description',
    descriptionRequired: 'Please enter description',
    descriptionEn: 'Description (EN)',
    descriptionEnPlaceholder: 'Enter description in English',
    descriptionEnRequired: 'Please enter description in English',
    label: 'Labels',
    labelPlaceholder: 'Separate multiple labels with commas',
    labelRequired: 'Please enter labels',
    labelEn: 'Labels (EN)',
    labelEnPlaceholder: 'Separate multiple labels with commas',
    labelEnRequired: 'Please enter labels in English',
    sort: 'Sort',
    sortPlaceholder: 'Enter sort order',
    sortRequired: 'Please enter sort order',
    webUrl: 'Web URL',
    webUrlPlaceholder: 'Enter web URL',
  },
}
